/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusThemenbereichDetailDto } from '../../models/lexplus-themenbereich-detail-dto';

export interface ThemenbereicheControllerFindDetailsOfGroupByIdV1$Params {
  themenbereichId: number;
}

export function themenbereicheControllerFindDetailsOfGroupByIdV1(http: HttpClient, rootUrl: string, params: ThemenbereicheControllerFindDetailsOfGroupByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusThemenbereichDetailDto>> {
  const rb = new RequestBuilder(rootUrl, themenbereicheControllerFindDetailsOfGroupByIdV1.PATH, 'get');
  if (params) {
    rb.path('themenbereichId', params.themenbereichId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusThemenbereichDetailDto>;
    })
  );
}

themenbereicheControllerFindDetailsOfGroupByIdV1.PATH = '/v1/themenbereiche/group-details/{themenbereichId}';
